const ID_ACCESS_TOKEN = 'access_token';
const ID_REFRESH_TOKEN = 'refresh_token';

export const getToken = () => {
  return window.localStorage.getItem(ID_ACCESS_TOKEN);
};

export const getRefreshToken = () => {
  return window.localStorage.getItem(ID_REFRESH_TOKEN);
};

export const saveToken = jwt => {
  window.localStorage.setItem(ID_ACCESS_TOKEN, jwt.access_token);
  window.localStorage.setItem(ID_REFRESH_TOKEN, jwt.refresh_token);
};

export const destroyToken = () => {
  window.localStorage.removeItem(ID_ACCESS_TOKEN);
  window.localStorage.removeItem(ID_REFRESH_TOKEN);
};

export default { getToken, getRefreshToken, saveToken, destroyToken };
